







































































































































































































































































































































import { Vue, Component } from "nuxt-property-decorator";
import GrPublicFooter from "~/components/startPageNew/GrPublicFooter.vue";

// import gsap from "gsap";

@Component({
  components: { GrPublicFooter },
})
export default class TermsOfUsePage extends Vue {
  tab = 0;

  head() {
    return {
      title: this.$t("Användarvillkor").toString(),
      // meta: [
      //   {
      //     hid: "description",
      //     name: "description",
      //     content:
      //       "Grundarna av Gritify är utvecklare, ekonomer och ingenjörer som är uppbackade av förändringsbenägna rekryterare och ledande HR-personligheter.",
      //   },
      // ],
    };
  }

  get backgroundImageSize(): string {
    switch (this.$vuetify.breakpoint.name) {
      case "xs":
        return "200%";
      case "sm":
        return "160%";
      default:
        return "100%";
    }
  }

  get heroTopTapping(): string {
    switch (this.$vuetify.breakpoint.name) {
      case "xs":
        return "110px";
      case "sm":
        return "180px";
      case "md":
        return "160px";
      case "lg":
        return "200px";
      default:
        return "200px";
    }
  }
}
